module.exports = __webpack_public_path__ + "static/DeChartDesktop-0e8237ee5ff41961354010914e0296df.svg";